import React, { useState, useEffect } from "react";
import "./Reports.css";
import config from "./config";

const Reports = ({ team, isAdmin, userID, refreshUserAccountInfo, userAccountInfo }) => {
  const API_URL = config.API_URL;
  const [selectedTeamMembers, setSelectedTeamMembers] = useState(team?.map((member) => ({ userId: member.UserId, checked: true })) || []);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState("");

  // Handle checkbox toggle
  const toggleCheckbox = (userId) => {
    setSelectedTeamMembers((prev) => prev.map((member) => (member.userId === userId ? { ...member, checked: !member.checked } : member)));
  };

  useEffect(() => {
    refreshUserAccountInfo();
  }, [refreshUserAccountInfo]);

  // Handle "Run Report" button click
  const handleRunReport = async () => {
    setIsSubmitting(true);
    setMessage(""); // Clear previous messages

    // Get the list of checked team member IDs
    const selectedIds = selectedTeamMembers.filter((member) => member.checked).map((member) => member.userId);

    if (selectedIds.length === 0) {
      setMessage("Please select at least one team member.");
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await fetch(`${API_URL}api/User/StartDiagnostics`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(selectedIds),
      });

      if (response.ok) {
        setMessage("Diagnostics started successfully!");
      } else {
        const errorData = await response.json();
        setMessage(`Error: ${errorData.message || "Unable to start diagnostics."}`);
      }
    } catch (error) {
      setMessage("An error occurred while starting diagnostics. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="reports-container">
      <h2>Generate Team Diagnostics Report</h2>

      {/* Run Report Button */}
      <button className="run-report-button" onClick={handleRunReport} disabled={isSubmitting}>
        {isSubmitting ? "Running Report..." : "Run Report"}
      </button>

      {/* Display Message */}
      {message && <p className="message">{message}</p>}

      {/* Team Members List */}
      <div className="team-members-list">
        {team?.map((member) => (
          <div key={member.UserId} className="team-member-item">
            <label>
              <input
                type="checkbox"
                checked={selectedTeamMembers.find((m) => m.userId === member.UserId)?.checked}
                onChange={() => toggleCheckbox(member.UserId)}
              />
              {member.UserEmail}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Reports;
